import { Injectable } from '@angular/core';
import { RuntimeConfig } from './runtime-config';

@Injectable({
  providedIn: 'root'
})
export class RuntimeConfigService {

  private readonly config: RuntimeConfig;

  constructor() {
    this.config = window.__env;

    if (!this.config || !this.config.API_URL) {
      console.error('❌ Runtime configuration missing');
    }
  }

  get env(): string {
    return this.config.ENVIRONMENT;
  }

  get authClientId(): string {
    return this.config.CLIENT_ID;
  }

  get authTenantId(): string {
    return this.config.TENANT_ID;
  }

  get scopes(): string {
    return this.config.SCOPES;
  }

  get graphApi(): string {
    return this.config.GRAPH_API;
  }

  get apimSubscriptionKey(): string {
    return this.config.APIM_SUBSCRIPTION_KEY;
  }

  get apiUrl(): string {
    return this.config.API_URL;
  }

  get apiVersion(): string {
    return this.config.API_VERSION;
  }

  get buildNumber(): string {
    return this.config.BUILD_NUMBER;
  }
}
